import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import willvalidate from 'willvalidate'
import router from './router'
import store from './store'
import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'
import VueScrollTo from 'vue-scrollto'
import axios from 'axios'
import VueSwal from 'vue-swal'
import VueTheMask from 'vue-the-mask'
// import VueSocketIO from 'vue-socket.io'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(willvalidate)
Vue.use(Toaster, {timeout: 4000})
Vue.use(VueScrollTo,
  {
    container: 'main',
    duration: 1,
    offset: -58
  }
)
Vue.use(VueSwal)
Vue.use(VueTheMask)

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: 'http://185.146.3.69:80',
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_'
//   }
// }))

Vue.mixin({
  methods: {
    processingResponseApi: function (status, token = null) {
      if (status === 'success') {
        if (token !== 'success' && token !== null && this.$store.state.authentication) {
          this.$store.commit('profile', [])
          this.$store.commit('authentication', false)
          this.$toaster.error('Сессия устарела, перезайдите')
        }
        return true
      } else if (status === 'er-token-not-found') {
        this.$store.commit('authentication', false)
        this.$toaster.error('Необходимо авторизоваться')
      } else if (status === 'er-access-denied') {
        this.$toaster.error('Доступ запрещен')
      } else {
        return false
      }
    },
    timesFormat (t, key) {
      let time = {
        1: ['00:00', 'Ночь', '0'],
        2: ['00:30', 'Ночь', '0'],
        3: ['01:00', 'Ночь', '1'],
        4: ['01:30', 'Ночь', '1'],
        5: ['02:00', 'Ночь', '2'],
        6: ['02:30', 'Ночь', '2'],
        7: ['03:00', 'Ночь', '3'],
        8: ['03:30', 'Ночь', '3'],
        9: ['04:00', 'Ночь', '4'],
        10: ['04:30', 'Ночь', '4'],
        11: ['05:00', 'Ночь', '5'],
        12: ['05:30', 'Ночь', '5'],
        13: ['06:00', 'Утро', '6'],
        14: ['06:30', 'Утро', '6'],
        15: ['07:00', 'Утро', '7'],
        16: ['07:30', 'Утро', '7'],
        17: ['08:00', 'Утро', '8'],
        18: ['08:30', 'Утро', '8'],
        19: ['09:00', 'Утро', '9'],
        20: ['09:30', 'Утро', '9'],
        21: ['10:00', 'Утро', '10'],
        22: ['10:30', 'Утро', '10'],
        23: ['11:00', 'Утро', '11'],
        24: ['11:30', 'Утро', '11'],
        25: ['12:00', 'День', '12'],
        26: ['12:30', 'День', '12'],
        27: ['13:00', 'День', '13'],
        28: ['13:30', 'День', '13'],
        29: ['14:00', 'День', '14'],
        30: ['14:30', 'День', '14'],
        31: ['15:00', 'День', '15'],
        32: ['15:30', 'День', '15'],
        33: ['16:00', 'День', '16'],
        34: ['16:30', 'День', '16'],
        35: ['17:00', 'День', '17'],
        36: ['17:30', 'День', '17'],
        37: ['18:00', 'Вечер', '18'],
        38: ['18:30', 'Вечер', '18'],
        39: ['19:00', 'Вечер', '19'],
        40: ['19:30', 'Вечер', '19'],
        41: ['20:00', 'Вечер', '20'],
        42: ['20:30', 'Вечер', '20'],
        43: ['21:00', 'Вечер', '21'],
        44: ['21:30', 'Вечер', '21'],
        45: ['22:00', 'Ночь', '22'],
        46: ['22:30', 'Ночь', '22'],
        47: ['23:00', 'Ночь', '23'],
        48: ['23:30', 'Ночь', '23']
      }
      return time[t][key]
    },
    spanFormat (span) {
      let spans = {
        1: '30 минут',
        2: '1 час',
        3: '1,5 часов',
        4: '2 часа',
        5: '2,5 часа',
        6: '3 часа',
        7: '3,5 часов',
        8: '4 часа',
        9: '4,5 часов',
        10: '5 часов',
        11: '5,5 часов',
        12: '6 часов',
        13: '6,5 часов',
        14: '7 часов'
      }
      return spans[span]
    },
    timestampToDate (timestamp) {
      let ts = new Date(timestamp * 1000)
      return ts.toLocaleDateString()
    },
    saveParamsList: function (list, params) {
      console.log('params', params)
      localStorage.setItem(list, JSON.stringify(params))
    },
    getParamsList: function (list) {
      console.log('local', localStorage)
      if (localStorage.getItem(list) !== 'undefined') {
        return JSON.parse(localStorage.getItem(list))
      } else {
        localStorage.setItem(list, null)
        return null
      }
    },
    goBack: function () {
      this.$router.go(-1)
    },
    localLoader () {
      document.getElementById('localPreloader').style.zIndex = '1000'
      document.getElementById('localPreloader').style.opacity = '1'
    },
    localLoaderFinish () {
      document.getElementById('localPreloader').style.zIndex = '-100'
      document.getElementById('localPreloader').style.opacity = '0'
    },
    priceFormat (number) {
      if (number !== '' && number !== 'null' && number !== null) {
        let price = number.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
        return price
      } else {
        return 0
      }
    },
    addFav (id, p_id) {
      let params = new URLSearchParams()
      params.append('partner_id', id)
      axios.post(this.$store.state.api.url + 'catalog/add-fav/', params, {withCredentials: true})
        .then((response) => {
          if (response.data.status === 'success') {
            if (response.data.type === 'add') {
              this.$toaster.success('Добавлено в избранное')
              this.$store.commit('globalCatalogFav', { partner_id: p_id, type: 1 })
            } else {
              this.$toaster.success('Удалено из избранного')
              this.$store.commit('globalCatalogFav', { partner_id: p_id, type: null })
            }
          }
          this.$store.state.globalPreloader = false
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    addFavFav (id, p_id) {
      let params = new URLSearchParams()
      params.append('partner_id', id)
      axios.post(this.$store.state.api.url + 'catalog/add-fav/', params, {withCredentials: true})
        .then((response) => {
          if (response.data.status === 'success') {
            if (response.data.type === 'add') {
              this.$toaster.success('Добавлено в избранное')
              this.$store.commit('globalFavFav', { partner_id: p_id, type: 1 })
            } else {
              this.$toaster.success('Удалено из избранного')
              this.$store.commit('globalFavFav', { partner_id: p_id, type: null })
            }
          }
          this.$store.state.globalPreloader = false
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
})

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  created: function () {
    axios.get(this.$store.state.api.url + 'authentication/check-token/', { withCredentials: true })
      .then((response) => {
        if (response.data.status === 'success') {
          this.$store.commit('authentication', true)
          this.$store.commit('profile', response.data.profile)
          this.$store.commit('otherAuth', response.data.otherAuth)
        } else {
          this.$store.commit('authentication', false)
          this.$store.commit('profile', [])
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  methods: {
    inArray (element, mass) {
      if (mass !== null) {
        let i
        for (i = 0; i < mass.length; i++) {
          if (element === mass[i]) {
            return true
          }
        }
        return false
      }
    }
  },
  // sockets: {
  //   connect: function () {
  //     console.log('socket connected')
  //   },
  //   newBooking: function (data) {
  //     if (this.inArray(data, this.$store.state.uniqKeyBookingPull)) {
  //       document.getElementById('u_' + data.toString()).innerHTML = 'Данное время заняли'
  //     }
  //   },
  //   messageRoom: function (data) {
	 //    this.$toaster.success(data)
	 //    axios.get(this.$store.state.api.url + 'authentication/update-socket?socket_id=' + data.socketId, { withCredentials: true })
  //       .then((response) => {
  //         if (response.data.status === 'success') {
  //         }
  //       })
  //       .catch(function (error) {
  //         console.log(error)
  //       })
  //   },
  //   reservTableMessagePartner: function (data) {
  //     this.$store.commit('reservTable', data)
  //     if (data.status === 1) {
	 //      this.$toaster.success('Новое бронирование столика')
  //     } else if (data.status === 0 && data.type !== 'open') {
	 //      this.$toaster.warning('Отмена бронирования')
  //     }
  //   },
  //   reservTableMessage: function (data) {
  //     this.$store.commit('reservTable', data)
  //   },
  //   answerReservTable: function (data) {
  //     if (data.status === 2) {
  //       this.$toaster.success('Ваша бронь подтверждена')
  //     } else {
  //       this.$toaster.success('Ваша бронь отменена')
	 //      this.$store.commit('reservTable', data)
  //     }
  //   },
	 //  orderTableMessagePartner: function (data) {
		//   this.$toaster.success('Новый заказ')
	 //  }
  // }

})



// WEBPACK FOOTER //
// ./src/main.js